import { motion } from "framer-motion";
import { Truck, Droplets, ShieldCheck, Timer } from "lucide-react";

const FEATURES = [
  {
    icon: Truck,
    title: "Gratis verzending vanaf €50",
    text: "Express geleverd in heel Nederland & België.",
    color: "#00FF66",
  },
  {
    icon: Droplets,
    title: "10.000 orbs inbegrepen",
    text: "Bij elke blaster. Gewoon in water weken en knallen maar.",
    color: "#00E5FF",
  },
  {
    icon: ShieldCheck,
    title: "100% veilig & niet-toxisch",
    text: "Zachte water-orbs die bij impact uiteenspatten. Geen blauwe plekken.",
    color: "#FF087B",
  },
  {
    icon: Timer,
    title: "Voor 23:00 = morgen in huis",
    text: "Bestel vandaag, splat morgen de tuin door.",
    color: "#00FF66",
  },
];

export const FeatureStrip = () => (
  <section id="waarom" data-testid="features-section" className="py-24 border-t border-slate-800/60">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-14"
      >
        <p className="font-mono-brand text-xs uppercase tracking-widest text-[#00E5FF] mb-3">Waarom Gelvaro</p>
        <h2 className="font-display text-5xl sm:text-6xl uppercase tracking-wide text-white leading-none">
          Gebouwd voor <span className="text-gradient-splat">chaos</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {FEATURES.map((f, i) => (
          <motion.div
            key={f.title}
            data-testid={`feature-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="bg-slate-900/60 border border-slate-800 rounded-3xl p-7 hover:border-slate-600 transition-colors"
          >
            <div
              className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5"
              style={{ backgroundColor: `${f.color}1A`, border: `1px solid ${f.color}44` }}
            >
              <f.icon className="w-6 h-6" style={{ color: f.color }} />
            </div>
            <h3 className="font-bold text-white text-lg leading-snug">{f.title}</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{f.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
